import { render } from "./ProjectSummary.vue?vue&type=template&id=595698d2&ts=true"
import script from "./ProjectSummary.vue?vue&type=script&lang=ts"
export * from "./ProjectSummary.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__